/**
 * @generated SignedSource<<3f43dc1c314413857d1a29a5d5c3783a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "vpprId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "stage",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "VppRTUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateVppRTPayload",
        "kind": "LinkedField",
        "name": "updateVppRTByVpprId",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "VppRT",
            "kind": "LinkedField",
            "name": "vppRT",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "VppRTUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateVppRTPayload",
        "kind": "LinkedField",
        "name": "updateVppRTByVpprId",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "VppRT",
            "kind": "LinkedField",
            "name": "vppRT",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "nodeId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "17308d9bdb108b3516febd414feb91ac",
    "id": null,
    "metadata": {},
    "name": "VppRTUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation VppRTUpdateMutation(\n  $input: UpdateVppRTByVpprIdInput!\n) {\n  updateVppRTByVpprId(input: $input) {\n    vppRT {\n      vpprId\n      stage\n      nodeId\n    }\n  }\n}\n"
  }
};
})();

node.hash = "4ad94998f8d0b3fbdbc329df70e27490";

module.exports = node;
